import request from './request'
import auth from './auth'
import region from './region'
import file from './file'
import process from './process'

export default {
  request,
  auth,
  region,
  file,
  process
}
